import styled from "styled-components";

export const Container = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 50;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: rgba(0, 0, 0, 0.5);

  .space-x {
    display: flex;
    gap: 1rem;
  }

  .opacity-50 {
    opacity: 0.5;
  }
`;

export const Modal = styled.div`
  background-color: var(--gray-100);
  border-radius: 8px;
  padding: 2rem;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.2);
  max-height: 80%;
  overflow-x: auto;
  animation: modal 0.2s linear;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;

  @keyframes modal {
    from {
      opacity: 0;
      transform: translateY(50px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;

export const Title = styled.h1`
  text-align: center;
  font-size: 1.5rem;
`;

export const Button = styled.button`
  padding: 0.5rem 1rem;
  border-radius: 8px;
  background-color: var(--brand-600);
  color: var(--gray-50);
  border: none;
  font-weight: 500;

  &:hover {
    filter: brightness(0.9);
  }

  &.right {
    align-self: flex-end;
  }

  &.large {
    font-size: 1.2rem;
  }
`;

export const QrCodeTitle = styled.h2`
  text-align: center;
  font-size: 1rem;
`;

export const QrCodeContent = styled.div`
    display: flex;
    flex-direction: column;
    h2 {
      margin-bottom: 1rem;
    }
    .qrcodeActions {
      margin-top: 1.5rem;
    }
    @media (max-width: 400px) {
      .qrcodeImage {
        width: 150px;
      }
    }
`;

export const QrCodeActions = styled.div`
    display: flex;
    justify-content: space-around;
    svg, a {
        cursor: pointer; 
    }
`;
